import { render, staticRenderFns } from "./AddIntrumentModal.vue?vue&type=template&id=08c6e805&scoped=true"
import script from "./AddIntrumentModal.vue?vue&type=script&lang=js"
export * from "./AddIntrumentModal.vue?vue&type=script&lang=js"
import style0 from "./AddIntrumentModal.vue?vue&type=style&index=0&id=08c6e805&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c6e805",
  null
  
)

export default component.exports